import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Table,
  Nav,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import {
  delete_generic,
  get_generic,
  post_generic,
  put_generic,
} from "../../../services/http_operations";
import {
  Capitalize,
  ReplaceUnderscores,
} from "../../../services/misc_functions";
export default function PostKPIPage() {
  //message for user
  const [msg, setMsg] = useState("");
  const [isError, setIsError] = useState(false);

  //data
  const [devices, setDevices] = useState(null);
  const [things, setThings] = useState(null);
  const [features, setFeatures] = useState(null);

  const [kpiList, setKpiList] = useState(null);

  const [operation, setOperation] = useState(null);
  const [selectedThing, setSelectedThing] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [selectedKPI, setSelectedKPI] = useState(null);

  const [kpiValues, setKpiValues] = useState(null);
  const [kpiDescValues, setKpiDescValues] = useState(null);

  const [tableRows, setTableRows] = useState(undefined);
  const [measurements, setMeasurements] = useState(undefined);

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const responseThings = await get_generic("things", {
          limit: -1,
          select: ["_id", "description"],
          sort: JSON.stringify({ _id: "asc" }),
        });
        const responseFeatures = await get_generic("features", {
          limit: -1,
        });
        const responseDevices = await get_generic("devices", {
          limit: -1,
          sort: JSON.stringify({ _id: "asc" }),
        });
        //fare la variabile che tiene tutte le things e la description, poi mettere nei navlink la description

        setThings(responseThings.docs);
        setDevices(responseDevices.docs);
        setFeatures(responseFeatures.docs);

        console.log({
          things: responseThings.docs,
          devices: responseDevices.docs,
          features: responseFeatures.docs,
        });
      } catch (error) {
        console.error(error);
        setMsg("Cannot fetch required resources");
        setIsError(true);
      }
    };

    fetchdata();
  }, []);

  //utilities
  const resetTableRows = async (enabler) => {
    try {
      const responseMeas = await get_generic("measurements", {
        limit: -1,
        filter: JSON.stringify({ thing: enabler }),
        sort: JSON.stringify({ device: "desc", feature: "desc" }),
      });

      const _tableRows = [];
      const _measurements = responseMeas.docs;
      _measurements
        .filter((meas) => !meas.feature.includes("_description"))
        .forEach((meas) => {
          const _feature = features.find((f) => f._id === meas.feature);
          const descMeas = _measurements.find(
            (m) =>
              m.feature === meas.feature + "_description" &&
              m.thing === meas.thing &&
              m.device === meas.device
          );

          const _rows = meas.samples[0].values.map((v, i) => {
            return {
              thing: meas.thing,
              feature: meas.feature,
              device: ReplaceUnderscores(meas.device),
              KPI_Tech_RQ: _feature.description,
              techKpi: ReplaceUnderscores(_feature.items[i].name),
              techLoggingReqs: _feature.items[i].description,
              KPI_Index: meas.feature.split("_")[1],
              status: meas.stage,
              kpiSubIndex: meas.samples[0].values.length !== 1 ? i : "",
              KPI_Value: v,
              KPI_Personal_Description: descMeas.samples[0].values[i],
              id: meas._id,
              descId: descMeas._id,
            };
          });

          _tableRows.push(_rows);
        });
      setTableRows(_tableRows.reverse().flat());
      setMeasurements(_measurements);
    } catch (error) {
      console.error(error);
    }
  };

  //callbacks

  //enabler tab is selected
  const handleChangeEnabler = async (e) => {
    setSelectedThing(e);

    setSelectedDevice(null);
    setSelectedFeature(null);
    setSelectedKPI(null);

    setOperation(null);
    resetTableRows(e);
  };

  const handleChangeDevice = (e) => {
    e.preventDefault();
    setSelectedFeature(null);
    setKpiList(null);
    setSelectedKPI(null);

    const _featuresList = features.filter(
      (f) =>
        !f._id.endsWith("_description") &&
        devices.find((d) => d._id === e.target.value).features.includes(f._id)
    );
    const _kpiNames = _featuresList
      .map((f) => {
        return {
          feature: f,
          string:
            f._id.split("_")[1] + " - " + f.items[0].name.split(/[\(\[]/)[0],
        };
      })
      .reverse();

    setSelectedDevice(e.target.value);
    setKpiList(_kpiNames);
  };
  const handleChangeKpi = (e) => {
    const _kpi = e.target.value;
    const _feature = features.find((f) => f._id === _kpi);
    const _featureDesc = features.find((f) => f._id === _kpi + "_description");
    const _measKpi = measurements.find(
      (m) =>
        m.feature === _kpi &&
        m.thing === selectedThing &&
        m.device === selectedDevice
    );
    const _measKpiDesc = measurements.find(
      (m) =>
        m.feature === _kpi + "_description" &&
        m.thing === selectedThing &&
        m.device === selectedDevice
    );
    setSelectedFeature(_feature);
    setSelectedKPI(_kpi);
    let _kpiValues = [];
    let _kpiDescValues = [];
    if (_measKpi !== undefined) {
      _kpiValues = _kpiValues.concat(_measKpi.samples[0].values);
    }
    if (_measKpiDesc !== undefined) {
      _kpiDescValues = _kpiDescValues.concat(_measKpiDesc.samples[0].values);
    } else {
      _kpiDescValues = _kpiDescValues.concat(_featureDesc.items.map((e) => ""));
    }
    setKpiValues(_kpiValues);
    setKpiDescValues(_kpiDescValues);
  };
  const handleEdit = (_device, _kpi) => {
    const _feature = features.find((f) => f._id === _kpi);
    const _featuresList = features.filter(
      (f) =>
        !f._id.endsWith("_description") &&
        devices.find((d) => d._id === _device).features.includes(f._id)
    );
    const _kpiNames = _featuresList
      .map((f) => {
        return {
          feature: f,
          string: f._id.split("_")[1] + " - " + f.items[0].name.split("(")[0],
        };
      })
      .reverse();

    const _measKpi = measurements.find(
      (m) =>
        m.feature === _kpi && m.thing === selectedThing && m.device === _device
    );
    const _measKpiDesc = measurements.find(
      (m) =>
        m.feature === _kpi + "_description" &&
        m.thing === selectedThing &&
        m.device === _device
    );
    let _kpiValues = [];
    let _kpiDescValues = [];
    if (_measKpi !== undefined) {
      _kpiValues = _kpiValues.concat(_measKpi.samples[0].values);
    }
    if (_measKpiDesc !== undefined) {
      _kpiDescValues = _kpiDescValues.concat(_measKpiDesc.samples[0].values);
    }

    setSelectedFeature(_feature);
    setKpiList(_kpiNames);
    setSelectedDevice(_device);
    setSelectedKPI(_kpi);
    setKpiValues(_kpiValues);
    setKpiDescValues(_kpiDescValues);
    setOperation("edit");
  };

  const handleKpiChanges = (value, index) => {
    const newValues = [...kpiValues];
    newValues[index] = isNaN(parseInt(value, 10)) ? null : parseInt(value, 10);

    setKpiValues(newValues);
  };

  const handleKpiDescChange = (value, index) => {
    const newValues = [...kpiDescValues];
    newValues[index] = value;
    setKpiDescValues(newValues);
  };

  const handleDelete = async (id) => {
    const confirm = window.confirm("The KPI will be deleted, proceed?");
    const meas = measurements.find((m) => m._id === id);
    const descMeas = measurements.find(
      (m) =>
        m.feature === meas.feature + "_description" &&
        m.thing === meas.thing &&
        m.device === meas.device
    );

    if (confirm === false) return;
    try {
      await delete_generic("measurements", id);
      await delete_generic("measurements", descMeas._id);

      setSelectedDevice(null);
      setSelectedFeature(null);
      setSelectedKPI(null);

      setOperation(null);

      resetTableRows(selectedThing);
    } catch (error) {
      console.error(error);
    }
  };

  const handleConsolidate = async (id, descId) => {
    const confirm = window.confirm("The KPI will be consolidated, proceed?");
    if (confirm === false) return;
    else {
      try {
        await put_generic(
          "measurements",
          {
            stage: "issued",
          },
          id
        );
        await put_generic(
          "measurements",
          {
            stage: "issued",
          },
          descId
        );
        resetTableRows(selectedThing);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();
    if (kpiValues.length === 0) {
      alert("Please, enter at least one KPI value");
      return;
    }
    if (kpiValues.every((el) => el === "" || el === null) === true) {
      alert("Please, enter at least one KPI value");
      return;
    }
    const measure = {
      thing: selectedThing,
      feature: selectedKPI,
      device: selectedDevice,
      stage: "draft",
      samples: [{ values: kpiValues }],
    };

    const descMeasure = {
      thing: selectedThing,
      feature: selectedKPI + "_description",
      device: selectedDevice,
      stage: "draft",
      samples: [{ values: kpiDescValues }],
    };

    const _measKpi = measurements.find(
      (m) =>
        m.feature === selectedKPI &&
        m.thing === selectedThing &&
        m.device === selectedDevice
    );
    const _measKpiDesc = measurements.find(
      (m) =>
        m.feature === selectedKPI + "_description" &&
        m.thing === selectedThing &&
        m.device === selectedDevice
    );

    try {
      if (_measKpi !== undefined)
        await delete_generic("measurements", _measKpi._id);
      if (_measKpiDesc !== undefined)
        await delete_generic("measurements", _measKpiDesc._id);
      const response = await post_generic("measurements", measure);
      console.log(selectedKPI);
      console.log(features.find((f) => f._id === selectedKPI));
      console.log(response);
      await post_generic("measurements", descMeasure);
      alert("KPIs " + operation + "ed successfully");

      resetTableRows(selectedThing);
      setOperation(null);
      setSelectedKPI(null);
      setSelectedFeature(null);
      setSelectedDevice(null);
    } catch (error) {
      console.error(error);
    }
  };

  const cancelCallback = (e) => {
    e.preventDefault();
    setSelectedKPI(null);
    setSelectedFeature(null);
    setOperation(null);
  };
  return (
    <div className="page">
      <header className="page-header">Post KPIs</header>
      <main className="page-content">
        {things === null ? (
          " Loading"
        ) : (
          <Nav
            justify
            variant="tabs"
            className="justify-content-center"
            onSelect={handleChangeEnabler}
            defaultActiveKey="form"
          >
            {React.Children.toArray(
              things.map((e) => {
                return (
                  <OverlayTrigger
                    overlay={<Tooltip>{e.description}</Tooltip>}
                    placement="top"
                    delayShow={300}
                    delayHide={150}
                  >
                    <Nav.Item>
                      <Nav.Link eventKey={e._id}>{e._id}</Nav.Link>
                    </Nav.Item>
                  </OverlayTrigger>
                );
              })
            )}
          </Nav>
        )}
        <Container
          fluid
          style={{
            border: 1 + "px solid lightGrey",
            backgroundColor: "white",
          }}
        >
          <EnablerTable
            tableRows={tableRows}
            handleEdit={handleEdit}
            handleConsolidate={handleConsolidate}
            handleDelete={handleDelete}
          />
          {tableRows !== undefined && operation === null && (
            <Button
              variant="outline-success"
              style={{
                border: "none",
                width: 50 + "px",
                height: 40 + "px",
                justifyContent: "center",
                textAlign: "center",
              }}
              onClick={(e) => {
                e.preventDefault();
                setOperation("post");
              }}
            >
              <i
                key={"icon"}
                className="fa fa-plus-circle"
                aria-hidden="true"
                title={"Add"}
                style={{
                  width: 30 + "px",
                  height: 30 + "px",
                  opacity: 0.85,
                }}
              />
            </Button>
          )}
          {operation !== null && (
            <React.Fragment>
              <Row>
                <Col>
                  <hr />
                </Col>
              </Row>
              <Row>
                <Col>
                  <b>{Capitalize(operation)} KPI form</b>
                </Col>
                <Col>
                  {!(
                    selectedFeature !== undefined &&
                    selectedFeature !== null &&
                    selectedDevice !== null &&
                    selectedDevice !== undefined
                  ) && (
                    <Button variant="warning" onClick={cancelCallback}>
                      Close Form
                    </Button>
                  )}
                </Col>
              </Row>

              <Row>
                <Col sm={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <b>
                        <i>Select Group</i>
                      </b>
                    </Form.Label>
                    <option>Select Group</option>
                    {devices === null ? (
                      " Loading"
                    ) : (
                      <Form.Select
                        disabled={operation === "edit"}
                        onChange={handleChangeDevice}
                        value={
                          selectedDevice !== null ? selectedDevice : "Group"
                        }
                      >
                        <option>Group</option>
                        {React.Children.toArray(
                          devices.map((e) => {
                            return (
                              <option value={e._id}>
                                {e._id + " - " + e.description}
                              </option>
                            );
                          })
                        )}
                      </Form.Select>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </React.Fragment>
          )}
          {selectedDevice !== undefined &&
            selectedDevice !== null &&
            kpiList !== undefined &&
            kpiList !== null && (
              <Row>
                <Col sm={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <b>
                        <i>Select KPI for {selectedDevice} Group</i>
                      </b>
                    </Form.Label>

                    <Form.Select
                      onChange={handleChangeKpi}
                      value={selectedKPI === null ? "" : selectedKPI}
                      disabled={operation === "edit"}
                    >
                      <option>Select KPI</option>
                      {React.Children.toArray(
                        kpiList.map((e) => {
                          return (
                            <option
                              value={e.feature._id}
                              disabled={
                                measurements.find(
                                  (m) =>
                                    m.feature === e.feature._id &&
                                    m.thing === selectedThing &&
                                    m.device === selectedDevice
                                ) !== undefined
                              }
                            >
                              {ReplaceUnderscores(e.string)}
                            </option>
                          );
                        })
                      )}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            )}
          {selectedFeature !== undefined &&
            selectedFeature !== null &&
            selectedDevice !== null &&
            selectedDevice !== undefined && (
              <KPIForm
                operation={operation}
                thing={selectedThing}
                device={selectedDevice}
                feature={selectedFeature}
                kpiValues={kpiValues}
                kpiDescValues={kpiDescValues}
                handleKpiChanges={handleKpiChanges}
                handleKpiDescChanges={handleKpiDescChange}
                submitCallback={submitForm}
                cancelCallback={cancelCallback}
              />
            )}

          <Row>
            <Col>
              <font
                style={{
                  marginLeft: 5 + "px",
                  color: isError ? "red" : "black",
                }}
              >
                {msg}
              </font>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}

function EnablerTable({
  tableRows,
  handleEdit,
  handleConsolidate,
  handleDelete,
}) {
  if (tableRows === undefined)
    return (
      <Row>
        <Col sm={3}>Please, select an Enabler tab to manage its KPIs</Col>
      </Row>
    );
  if (tableRows.length === 0)
    return (
      <Row>
        <Col sm={3}>No KPI already posted for this Enabler</Col>
      </Row>
    );

  return (
    <React.Fragment>
      <Row style={{ paddingTop: 20 + "px" }}>
        <Col sm={12}>
          <div
            style={{
              height: 30 + "vh",
              minHeight: 300 + "px",
              width: 100 + "%",
              overflow: "scroll",
            }}
          >
            <Table striped bordered hover size="lg">
              <thead>
                <tr>
                  <th style={{ width: "10%" }}>Group</th>
                  <th style={{ width: "20%" }}>Tech RQ</th>
                  <th style={{ width: "10%" }}>ID - Tech KPI</th>
                  <th style={{ width: "5%" }}>KPI Value</th>
                  <th style={{ width: "7%" }}>KPI Custom Description</th>
                  <th style={{ width: "5%" }}>Manage KPI</th>
                </tr>
              </thead>
              <tbody>
                {React.Children.toArray(
                  tableRows.map((r, i) => {
                    return (
                      <tr>
                        <td>
                          {i !== 0 && r.id === tableRows[i - 1].id
                            ? " "
                            : ReplaceUnderscores(r.device)}
                        </td>
                        <td>
                          {i !== 0 && r.id === tableRows[i - 1].id
                            ? " "
                            : r.KPI_Tech_RQ}
                        </td>

                        <td>
                          {r.KPI_Index}{" "}
                          {r.kpiSubIndex !== ""
                            ? "[" + r.kpiSubIndex + "]"
                            : ""}{" "}
                          - {ReplaceUnderscores(r.techKpi)}
                        </td>
                        <td>{r.KPI_Value}</td>
                        <td>{r.KPI_Personal_Description}</td>
                        <td>
                          {i !== 0 && r.id === tableRows[i - 1].id ? (
                            " "
                          ) : (
                            <React.Fragment>
                              <OverlayTrigger
                                overlay={
                                  <Tooltip id="edit">
                                    {r.status !== "draft"
                                      ? "Cannot edit a consolidated or finalized KPI"
                                      : "Edit KPI"}
                                  </Tooltip>
                                }
                                placement="top"
                                delayShow={300}
                                delayHide={150}
                              >
                                <Button
                                  variant={
                                    r.status !== "draft"
                                      ? "outline-secondary"
                                      : "outline-primary"
                                  }
                                  disabled={r.status !== "draft"}
                                  style={{
                                    pointerEvents: "all",
                                    border: "none",
                                    width: 50 + "px",
                                    height: 40 + "px",
                                    justifyContent: "center",
                                    textAlign: "center",
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleEdit(r.device, r.feature);
                                  }}
                                >
                                  <i
                                    key={"icon"}
                                    className="fa fa-pencil-alt"
                                    aria-hidden="true"
                                    style={{
                                      width: 30 + "px",
                                      height: 30 + "px",
                                      opacity: 0.85,
                                    }}
                                  />
                                </Button>
                              </OverlayTrigger>
                              <OverlayTrigger
                                overlay={
                                  <Tooltip id="consolidate">
                                    {r.status !== "draft"
                                      ? r.status === "final"
                                        ? "The KPI has been finalized"
                                        : "This KPI is already consolidated"
                                      : "Consolidate KPI"}
                                  </Tooltip>
                                }
                                placement="top"
                                delayShow={300}
                                delayHide={150}
                              >
                                <Button
                                  disabled={r.status !== "draft"}
                                  variant={
                                    r.status !== "draft"
                                      ? r.status === "final"
                                        ? "outline-success"
                                        : "outline-warning"
                                      : "outline-danger"
                                  }
                                  style={{
                                    pointerEvents: "all",
                                    border: "none",
                                    width: 50 + "px",
                                    height: 40 + "px",
                                    justifyContent: "center",
                                    textAlign: "center",
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleConsolidate(r.id, r.descId);
                                  }}
                                >
                                  <i
                                    key={"icon"}
                                    className="fa fa-circle"
                                    aria-hidden="true"
                                    style={{
                                      width: 30 + "px",
                                      height: 30 + "px",
                                      opacity: 0.85,
                                    }}
                                  />
                                </Button>
                              </OverlayTrigger>
                              <OverlayTrigger
                                overlay={
                                  <Tooltip id="delete">
                                    {r.status !== "draft"
                                      ? "Cannot delete a consolidated or finalized KPI"
                                      : "Delete KPI"}
                                  </Tooltip>
                                }
                                placement="top"
                                delayShow={300}
                                delayHide={150}
                              >
                                <Button
                                  disabled={r.status !== "draft"}
                                  variant={
                                    r.status !== "draft"
                                      ? "outline-secondary"
                                      : "outline-danger"
                                  }
                                  style={{
                                    pointerEvents: "all",
                                    border: "none",
                                    width: 50 + "px",
                                    height: 40 + "px",
                                    justifyContent: "center",
                                    textAlign: "center",
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleDelete(r.id);
                                  }}
                                >
                                  <i
                                    key={"icon"}
                                    className="fa fa-times"
                                    aria-hidden="true"
                                    style={{
                                      width: 30 + "px",
                                      height: 30 + "px",
                                      opacity: 0.85,
                                    }}
                                  />
                                </Button>
                              </OverlayTrigger>
                            </React.Fragment>
                          )}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}

function KPIForm({
  operation,
  thing,
  device,
  feature,
  kpiValues,
  kpiDescValues,
  handleKpiChanges,
  handleKpiDescChanges,
  submitCallback,
  cancelCallback,
}) {
  return (
    <React.Fragment>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col>{Capitalize(operation)} KPI</Col>
      </Row>

      <Row>
        <Col>
          Enabler:<i> {thing}</i>
        </Col>
      </Row>
      <Row>
        <Col>
          Group:<i> {device}</i>
        </Col>
      </Row>
      <Row>
        <Col>
          Tech RQs:<i> {feature.description}</i>
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
      <Form>
        <Row style={{ paddingBottom: 5 + "px" }}>
          <Col sm={1}>
            <b>KPI's index</b>
          </Col>
          <Col sm={3}>
            <b>KPI's name</b>
          </Col>
          <Col xxl={1} xl={2} lg={5} md={4} sm={3}>
            <b>Enter KPI value</b>
          </Col>
          <Col xxl={1} xl={2} lg={5} md={4} sm={3}>
            <b>
              Enter KPI description <i>(optional)</i>
            </b>
          </Col>
        </Row>
        {React.Children.toArray(
          feature.items.map((item, index) => {
            return (
              <React.Fragment>
                <Row style={{ paddingBottom: 5 + "px" }}>
                  <Col sm={1}>{feature._id.split("_")[1]}</Col>
                  <Col sm={3}>{ReplaceUnderscores(item.name)}</Col>
                  <Col xxl={1} xl={2} lg={5} md={4} sm={3}>
                    <Form.Control
                      //it may be required to manage different input type todo
                      type="number"
                      value={
                        kpiValues[index] !== undefined &&
                        kpiValues[index] !== null
                          ? kpiValues[index]
                          : ""
                      }
                      onChange={(e) => {
                        e.preventDefault();
                        handleKpiChanges(e.target.value, index);
                      }}
                    />
                  </Col>
                  <Col xxl={1} xl={2} lg={5} md={4} sm={3}>
                    <Form.Control
                      type="text"
                      value={
                        kpiDescValues[index] !== undefined
                          ? kpiDescValues[index]
                          : ""
                      }
                      onChange={(e) => {
                        e.preventDefault();
                        handleKpiDescChanges(e.target.value, index);
                      }}
                    />
                  </Col>
                </Row>
              </React.Fragment>
            );
          })
        )}
        <Button type="submit" onClick={submitCallback}>
          Submit changes
        </Button>
        &nbsp; &nbsp;
        <Button variant="warning" onClick={cancelCallback}>
          Cancel
        </Button>
      </Form>
    </React.Fragment>
  );
}
